export default "/images/instagram-footer.png?d650aae5d108ad0610a7eed765bd2300";